
var renderBill = function (Options) {
    var options = {
        id:null,
        name:'Name Goes Here!'
    };
    $.extend(options,Options );

    console.log('Mr Tone Bill - Rendering ' + options.id + ' ' + options.name);

    $('#' + options.id + ' #billName').text(options.name)

}

otuApp.mrToneBill = {
    renderBill
}